import { useMutation } from '@tanstack/react-query';
import { patch } from '../libs';

interface Payload {
  /** 메모 내용 */
  memo: string;
  /** 메모 id */
  coachMemoId: string;
}

/**
 * 코치 - 메모내용 수정
 * @link https://api-dev.fibud.kr/api#/%EA%B3%84%EC%A0%95/AccountsController_updateCoachMemo
 * @param param0
 * @returns
 */
export default function usePatchCoachMemoMutation() {
  return useMutation(({ coachMemoId, ...payload }: Payload) =>
    patch<string, Omit<Payload, 'coachMemoId'>>(
      `/accounts/coach-memo/${coachMemoId}`,
      payload
    )
  );
}
